import { Button } from "components/atoms/button/button";
import { Modal } from "components/modal/modal";
import { ModalSize } from "components/modal/modal.types";
import {
  ButtonWrapper,
  ClassTypeDescription,
  ClassTypeTitle,
  ClassTypeWrapper,
  ContentContainer,
  SlotTitle,
  ModalTitle,
  SelectedSlotCard,
  SelectedSlotWrapper,
  Divider,
  ModalContent,
  SlotTeacherName,
  SlotStartDateAndTeacherNameContainer,
  SlotDateAndTime,
  VerticalDivider
} from "./modal-slot-confirmation.styles";
import { ModalSlotConfirmationProps } from "./modal-slot-confirmation.types";
import useModalSlotConfirmation from "./use-modal-slot-confirmation";
import { renderClassStatusChip } from "../slot-card/slot-card";
import JadwalChangesInfoFromFeature from "components/jadwal/jadwal-changes-info/jadwal-changes-info-from-feature";

const ModalSlotConfirmation: React.FC<ModalSlotConfirmationProps> = (props) => {
  const { isOpen, sections, onClose } = props;

  const { handleSubmit, loading } = useModalSlotConfirmation(props);
  const mandatoryClasses = sections.filter(
    (section) => !section.is_optional || !section.selected_slot
  );
  const extraClasses = sections.filter(
    (section) => section.is_optional && section.selected_slot
  );

  return (
    <Modal isOpen={isOpen} onClose={onClose} size={ModalSize.ExtraWide}>
      <ModalTitle>Konfirmasi jadwal yang udah dipilih</ModalTitle>
      <ModalContent>
        <JadwalChangesInfoFromFeature />
        <ContentContainer>
          {mandatoryClasses.length > 0 && (
            <div>
              <ClassTypeWrapper>
                <ClassTypeTitle>Kelas Konsep</ClassTypeTitle>
                <ClassTypeDescription>
                  Kelas yang wajib diikuti 😉
                </ClassTypeDescription>
              </ClassTypeWrapper>

              {mandatoryClasses.map((section, key) => (
                <SelectedSlotWrapper key={key}>
                  <SelectedSlotCard>
                    <SlotTitle>
                      {section.selected_slot?.slot.course.name}
                    </SlotTitle>
                    <SlotDateAndTime>
                      {" "}
                      {section.selected_slot?.formatted_schedule}
                    </SlotDateAndTime>
                    <SlotStartDateAndTeacherNameContainer>
                      {section.selected_slot &&
                        renderClassStatusChip(
                          section.selected_slot?.slot.start_date
                        )}
                      {section.selected_slot?.slot.teacher && (
                        <>
                          {" "}
                          <VerticalDivider />
                          <SlotTeacherName>
                            Guru Juara :{" "}
                            {section.selected_slot.slot.teacher.name}
                          </SlotTeacherName>
                        </>
                      )}
                    </SlotStartDateAndTeacherNameContainer>
                  </SelectedSlotCard>
                </SelectedSlotWrapper>
              ))}
            </div>
          )}

          {extraClasses.length > 0 && (
            <>
              {mandatoryClasses.length > 0 && <Divider />}
              <div>
                <ClassTypeWrapper>
                  <ClassTypeTitle>Kelas Extra</ClassTypeTitle>
                  <ClassTypeDescription>
                    Kelas yang nggak wajib diikuti tapi bermanfaat 😁
                  </ClassTypeDescription>
                </ClassTypeWrapper>
                {extraClasses.map((extraClass, key) => (
                  <SelectedSlotWrapper key={key}>
                    <SelectedSlotCard>
                      <SlotTitle>
                        {extraClass.selected_slot?.slot.course.name}
                      </SlotTitle>
                      <SlotDateAndTime>
                        {extraClass?.selected_slot?.slot?.name}
                      </SlotDateAndTime>
                    </SelectedSlotCard>
                  </SelectedSlotWrapper>
                ))}
              </div>
            </>
          )}
        </ContentContainer>

        <ButtonWrapper>
          <Button isLoading={loading} onClick={handleSubmit} variant="primary">
            Sip! ini jadwal aku
          </Button>
        </ButtonWrapper>
      </ModalContent>
    </Modal>
  );
};

export { ModalSlotConfirmation };
